import React, { useState } from "react"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"

import RmTable from "./RmTable"
import RmSearch from "./RmSearch"
import { Navbar } from "components"
import RmFooter from "./RmFooter"
import classes from "./index.module.scss"

const RepositoryManagement = () => {
  const [t] = useTranslation()

  const [ordersForDispatch, setOrdersForDispatch] = useState([])

  const history = useHistory()

  const handleGoBack = () => {
    history.push("/settings")
  }

  return (
    <div className={classes["container"]}>
      <Navbar
        variant="compact"
        title={t("خروج_از_انبار")}
        onLeftIconPress={handleGoBack}
      />

      <div className={classes["wrapper"]}>
        <RmSearch
          setOrdersForDispatch={setOrdersForDispatch}
        />

        <RmFooter
          ordersForDispatch={ordersForDispatch}
          setOrdersForDispatch={setOrdersForDispatch}
        />

        <RmTable
          ordersForDispatch={ordersForDispatch}
          setOrdersForDispatch={setOrdersForDispatch}
        />
      </div>
    </div>
  )
}

export default RepositoryManagement